import React from 'react';
import { sendVerificationEmailAction } from '../../actions/emails';
import { verifyEmailWithCodeAction } from '../../actions/verification';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    IFrontendContext,
    MODAL_TYPES,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import {
    INotificationContext,
    useNotificationsContext,
} from '../../contexts/NotificationsContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';
import VerificationForm from '../forms/VerificationForm';
import TakeoverDialog from '../TakeoverDialog';

export interface IVerificationDialogProps {
    email: string;
    dataTestId?: string;
    target: string;
    onVerificationSuccessful: () => void;
    forceOpen?: boolean;
}

const VerificationDialog = ({
    email,
    dataTestId = 'verificationDialog',
    target,
    onVerificationSuccessful,
    forceOpen,
}: IVerificationDialogProps) => {
    const frontendContext: IFrontendContext = useFrontendContext();
    const configContext: IConfigContextProps = useConfigContext();
    const notificationsContext: INotificationContext =
        useNotificationsContext();
    const userContext: IUserContext = useUserContext();

    React.useEffect(() => {
        if (forceOpen) {
            frontendContext.methods.setShowModal(MODAL_TYPES.verification);
        }

        // else {
        //     frontendContext.methods.setShowModal(MODAL_TYPES.closed);
        // }
    }, [forceOpen, frontendContext.methods]);

    React.useEffect(() => {
        if (frontendContext?.state?.showModal === MODAL_TYPES.verification) {
            sendVerificationEmailAction({
                email,
                target,
                contexts: {
                    frontendContext,
                    configContext,
                    notificationsContext,
                    userContext,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email, sendVerificationEmailAction, frontendContext?.state?.showModal]);

    const _handleSubmitCode = (verificationCode: string) => {
        verifyEmailWithCodeAction({
            email,
            target,
            verificationCode,
            onVerificationSuccessful,
            contexts: {
                frontendContext,
                configContext,
                notificationsContext,
                userContext,
            },
        });
    };

    return (
        <TakeoverDialog
            onClose={() => {
                frontendContext.methods.setShowModal(MODAL_TYPES.closed);
            }}
            isShown={
                frontendContext.state.showModal === MODAL_TYPES.verification
            }
            containerClasses="eds-l-pad-all-8 eds-align--center"
        >
            <VerificationForm
                dataTestId={`${dataTestId}-form`}
                email={email}
                onSubmitCode={_handleSubmitCode}
                target={target}
            />
        </TakeoverDialog>
    );
};

export default VerificationDialog;
